if (process.env && process.env.NODE_ENV === 'production') {
  __webpack_public_path__ = window.__webpack_public_path__;
}
